export const PRODUCT_STATS_TABLE_WIDGET_SKELETON_HEIGHT = {
  sm: 40,
  md: 60,
  lg: 100,
};
